var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"container","appear":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.dialogStatus),expression:"$store.state.dialogStatus"}],staticClass:"dialogWrap"},[_c('div',{staticClass:"close-btn",on:{"click":function($event){return _vm.hideDialog()}}}),_c('div',{staticClass:"QRcode"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }